import { render, staticRenderFns } from "./backMember.vue?vue&type=template&id=ec93162c"
import script from "./backMember.vue?vue&type=script&lang=js"
export * from "./backMember.vue?vue&type=script&lang=js"
import style0 from "./backMember.vue?vue&type=style&index=0&id=ec93162c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports